import React from 'react';
import LawyerProfile from '../components/LawyerProfile';
import styles from '../assets/styles/WhoWeAre.module.css';
import imgKimani from '../assets/images/kimani_casual.jpg';
import imgYusef from '../assets/images/yusef_casual.jpg';
import imgLogo from '../assets/images/logo.jpg';

const WhoWeAre = () => {
  const kimaniBio = [
    "Mr. Boden is an experienced lawyer who was admitted to legal practice in 1996.",
    "Following his admission, Mr. Boden worked initially for Victoria Legal Aid before setting up Starnet Legal. He first worked as a general lawyer and then as a  Duty Lawyer at Victoria Legal Aid. This initial experience was invaluable because it trained Mr. Boden to work under extreme pressure and to deal with many clients, from different backgrounds within short time frames. This allowed him to focus on the core issues immediately, without being distracted by non-critical information.",
    "In 1999, Mr. Boden founded Starnet Legal in the inner Melbourne suburbs. He initially worked with his wife, who is also a lawyer and who now operates her own firm.",
    "During the last 25 years, Mr. Boden has continued to represent clients with the same passion and dedication as when he started. His motivation has always been to give people who may not otherwise be heard a voice. Indeed this desire for justice is what first inspired him to study law.",
    "Mr. Boden is a general litigation lawyer, who specialises in Commercial Litigation, Personal & Professional Negligence, Administrative Law, Alternative Dispute Resolution Family Law and Criminal Law."
  ];

  const yusefBio = [
    "Mr. Yusef Mohamed has been working in the area of law for the past four years. First starting out as a paralegal with Starnet Legal and was then admitted in June 2023. Mr. Mohamed has a close eye to detail and is someone whom will go the extra mile for you to reach your goals and an outcome. Mr. Mohamed believes that knowing your rights is your biggest asset, with this, he purposely dedicates time to the individuals whom may not know their rights or have the courage to stand up for themselves.",
    "Mr. Mohamed is guided by his mentor Mr. Boden and is a general litigation lawyer, who specialises in Family Law, Criminal Law, Alternative Dispute Resolution, Personal Injury which includes TAC and Work Cover Claim, and Commercial Litigation, and Immigration Law."
  ]


  return (
    <div id='about'>
      <div className={styles.content}>
        <div className={styles.title}>Starnet Legal is Here For You</div>
        <div className={styles.imgContainer}>
          <img className={styles.logo} src={imgLogo} alt='Starnet Legal Logo' />
        </div>
        <div className={styles.yapContainer}>
          <div className={styles.yap}>
            <div>Starnet Legal is a dedicated boutique law firm, which was specifically established to offer access to justice to as many individuals and businesses as possible.</div>
            <div>When you feel overwhelmed or think that no solution is there for your problem, contact us. We are known for our innovative approach to problem solving and always make sure that we remain outcome focused whilst ensuring that costs are proportionate to the dispute.</div>
            <div>We have extensive experience in dealing with clients from diverse backgrounds and understand that our past will influence and shape our decision making.</div>
            <div>We speak several languages and offer our own diverse backgrounds to the problem solving equation.</div>
            <div>In appropriate cases, we are prepared to act on a no win – no pay basis or a reduced fee model.</div>
            <div>Starnet Legal has been involved in landmark cases in several areas of law.</div>
          </div>
        </div>

        <div className={styles.lawyerProfilesContainer}>
          <div id="kimani">
            <LawyerProfile
              img={imgKimani}
              name="Kimani Adil Boden"
              title="Founding Lawyer"
              bioLines={kimaniBio}
            />
          </div>
          <div id="yusef">
            <LawyerProfile
              img={imgYusef}
              name="Yusef Mohamed"
              title="Senior Solicitor"
              bioLines={yusefBio}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhoWeAre;